import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ConfigForm } from './ConfigForm';
import { useAppConfig } from '@/contexts/AppConfigContext';
import { useWebSocket } from '@/contexts/WebSocketContext';
import { AppConfig } from '@/types';

interface ConnectionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ConnectionDialog({ open, onOpenChange }: ConnectionDialogProps) {
  const { config, validateAndSave } = useAppConfig();
  const { connect } = useWebSocket();
  const [errors, setErrors] = useState<string[]>([]);

  const handleSubmit = (newConfig: AppConfig) => {
    // Validate and save config
    const validation = validateAndSave(newConfig);

    if (!validation.valid) {
      setErrors(validation.errors);
      return;
    }

    // Clear errors
    setErrors([]);

    // Connect to WebSocket
    try {
      connect();
      // Close dialog after successful connection
      onOpenChange(false);
    } catch (error) {
      console.error('Connection failed:', error);
      setErrors(['Failed to connect to WebSocket. Please check your settings.']);
    }
  };

  const handleCancel = () => {
    setErrors([]);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>🔌 Kết nối Agent Console</DialogTitle>
          <DialogDescription>
            Configure connection settings to connect to your AI Agent
          </DialogDescription>
        </DialogHeader>
        <ConfigForm
          initialConfig={config}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          errors={errors}
        />
      </DialogContent>
    </Dialog>
  );
}
